<template lang="pug">
.uploadFile-container
    #upload-file
        el-upload.upload-demo(
            drag,
            :file-list='fileList',
            action='alert',
            :auto-upload='false',
            :on-change='onLoadFile',
            :on-remove='onRemoveFile',
            @click.native='centralizarArquivo($event)',
            :multiple='true',
            ref='upload'
        )
            .el-upload__text.mt-1.ml-3.text-left {{ $t('mensagens.menuMapa.observacoes.upload.1') }} <br> {{ $t('mensagens.menuMapa.observacoes.upload.2') }} </br>
            .borda-upload
                i.el-icon-upload(style='width: 68px')
                .el-upload__text {{ $t('mensagens.menuMapa.observacoes.dragAndDrop.1') }} <em> {{ $t('mensagens.menuMapa.observacoes.dragAndDrop.2') }} </em>
</template>

<script>
import geoJsonConverter from '@/utils/conversorGeojson';
import mapaEstilos from '@/utils/mapa/mapa.estilos';
import Mapa from '@/utils/mapa/mapa.service';

export default {
    name: 'UploadFile',
    props: {
        mapa: {
            required: true
        }
    },
    data() {
        return {
            visivel: false,
            geometria: null,
            fileList: [],
            collapseFiltroAvancado: '',
            geometrias: []
        };
    },

    methods: {
        fecharModalAoClicarFora(event) {
            if (!this.$el.contains(event.target)) {
                this.show(false);
            }
        },

        show(visivel) {
            this.visivel = visivel !== null ? visivel : !this.visivel;
            if (this.visivel) {
                document.body.addEventListener(
                    'click',
                    this.fecharModalAoClicarFora
                );
                document
                    .getElementById('upload-file')
                    .classList.remove('hideElement');
                document
                    .getElementById('upload-file')
                    .classList.add('showElement');
            } else {
                document.body.removeEventListener(
                    'click',
                    this.fecharModalAoClicarFora
                );
                document
                    .getElementById('upload-file')
                    .classList.remove('showElement');
                document
                    .getElementById('upload-file')
                    .classList.add('hideElement');
            }
        },

        centralizarArquivo(event) {
            const nomeArquivo = event.target.textContent.trim();
            if (this.geometrias) {
                this.geometrias.forEach(geometria => {
                    if (geometria.identificadorGeometria === nomeArquivo) {
                        var bounds = geometria.getBounds();
                        this.mapa.fitBounds(bounds);
                    }
                });
            }
        },

        onRemoveFile(file) {
            const geometria = this.geometrias.find(
                g => g.identificadorGeometria === file.name
            );
            if (geometria) {
                this.mapa.removeLayer(geometria);
                const index = this.geometrias.indexOf(geometria);
                if (index !== -1) {
                    this.geometrias.splice(index, 1);
                }
            }
        },
        onLimitExceed() {
            this.$notify.warning({
                message: this.$t(
                    'mensagens.menuMapa.notificacoes.umTerritorioPorVez'
                )
            });
        },

        onLoadFile(file) {
            let reader = new FileReader();

            let extension = file.name.split('.').pop().toLowerCase();

            reader.onload = async e => {
                await geoJsonConverter
                    .parse(extension, e.target.result, file.raw)
                    .then(geoJson => {
                        this.mostrarTerritorioNoMapa(
                            geoJson.features.map(f => f.geometry),
                            file.name
                        );
                    })
                    .catch(rejectReason => {
                        this.$refs.upload.clearFiles();
                        this.$notify.error({ message: rejectReason });
                    });
            };

            reader.readAsText(file.raw);
        },

        mostrarTerritorioNoMapa(geometria, identificadorGeometria) {
            const novaGeometria = Mapa.criarGeoJSON(
                geometria,
                mapaEstilos.Geometria.area
            );
            novaGeometria.identificadorGeometria = identificadorGeometria;
            this.mapa.addLayer(novaGeometria);
            this.geometrias.push(novaGeometria);
            var bounds = novaGeometria.getBounds();

            // Fit the map to the polygon bounds
            this.mapa.fitBounds(bounds);
        }
    }
};
</script>

<style lang="scss">
#botao-upload-file {
    width: 31px !important;
    height: 31px !important;
    min-width: 31px !important;
    color: var(--black);
    padding: 0 !important;
}

.uploadFile-container {
    display: flex;
}

#upload-file {
    background-color: var(--white);
    width: 350px;

    .el-upload-list__item-name {
        width: 100% !important;
        cursor: pointer;
    }

    .el-upload-dragger {
        height: 200px !important;
        border: none;
    }
}

.showElement {
    display: block;
    height: 155px;
}

.hideElement {
    display: none;
}

.borda-upload {
    border: 1px dashed #e4e7ed;
    margin: 0 10px 0 10px;
    height: 137px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .el-upload__text {
        font-size: 13px !important;

        em {
            color: #276fda !important;
        }
    }
}
</style>
